// Odpočet po špatném přihlášení (SignInControl): po dobu blokace je formulář neaktivní
// a ukazuje, za jak dlouho jde zkusit znovu. Server pokus během blokace stejně odmítne,
// tohle jen šetří uživateli zbytečné odeslání.

const formatTime = (seconds) => {
    if (seconds < 60) {
        return `${seconds} s`;
    }
    const minutes = Math.floor(seconds / 60);
    const rest = String(seconds % 60).padStart(2, '0');
    return `${minutes}:${rest} min`;
};

const startCountdown = (alert) => {
    const form = alert.closest('.login-form')?.querySelector('form');
    const time = alert.querySelector('.login-countdown-time');
    const end = Date.now() + Number(alert.dataset.loginCountdown) * 1000;
    const controls = form ? form.querySelectorAll('input, button, select, textarea') : [];

    controls.forEach((control) => { control.disabled = true; });

    const tick = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (remaining > 0) {
            time.textContent = formatTime(remaining);
            return;
        }

        clearInterval(timer);
        controls.forEach((control) => { control.disabled = false; });
        alert.classList.replace('alert-warning', 'alert-info');
        alert.textContent = 'Můžete se znovu přihlásit.';
    };

    const timer = setInterval(tick, 1000);
    tick();
};

const init = () => document.querySelectorAll('[data-login-countdown]').forEach(startCountdown);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
